module.exports = __webpack_public_path__ + "img/notice_工单逾期.jpg";